import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "w-100"
}
const _hoisted_2 = {
  class: "oss-dense-table",
  width: "100%"
}
const _hoisted_3 = {
  align: "center",
  width: "10%"
}
const _hoisted_4 = { class: "d-flex justify-space-around align-center" }
const _hoisted_5 = { width: "10%" }
const _hoisted_6 = { width: "10%" }
const _hoisted_7 = { width: "10%" }
const _hoisted_8 = { width: "60%" }
const _hoisted_9 = { class: "fill-width" }
const _hoisted_10 = {
  class: "oss-dense-table",
  width: "100%"
}
const _hoisted_11 = {
  key: 0,
  class: "d-flex justify-end"
}
const _hoisted_12 = {
  class: "oss-dense-table",
  width: "48%"
}
const _hoisted_13 = { width: "25%" }
const _hoisted_14 = { width: "25%" }
const _hoisted_15 = { width: "25%" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = {
  key: 1,
  class: "pa-2"
}
const _hoisted_18 = {
  "no-gutters": "",
  class: "d-flex pb-3"
}
const _hoisted_19 = {
  class: "d-flex",
  style: {"width":"15%"}
}
const _hoisted_20 = {
  class: "pl-2",
  style: {"width":"15%"}
}
const _hoisted_21 = {
  style: {"width":"25%"},
  class: "pl-2"
}
const _hoisted_22 = {
  class: "pl-2",
  style: {"width":"15%"}
}
const _hoisted_23 = {
  key: 0,
  class: "pl-2",
  style: {"width":"20%"}
}
const _hoisted_24 = {
  class: "pl-2 d-flex align-center",
  style: {"width":"10%"}
}
const _hoisted_25 = { class: "fill-width" }
const _hoisted_26 = {
  class: "oss-dense-table",
  width: "100%"
}
const _hoisted_27 = {
  key: 0,
  style: {"text-align":"center"}
}
const _hoisted_28 = {
  key: 1,
  style: {"text-align":"center"}
}
const _hoisted_29 = {
  key: 2,
  style: {"text-align":"center"},
  width: "5%"
}
const _hoisted_30 = { key: 3 }
const _hoisted_31 = ["colspan"]
const _hoisted_32 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_btn_trash = _resolveComponent("v-btn-trash")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_oss_date_picker = _resolveComponent("oss-date-picker")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_AccountingItemLine = _resolveComponent("AccountingItemLine")!
  const _component_oss_text_field = _resolveComponent("oss-text-field")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_oss_date_picker_filled = _resolveComponent("oss-date-picker-filled")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_FreeTag = _resolveComponent("FreeTag")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.onAccountingLinesPage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createElementVNode("tbody", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_v_btn_icon, {
                    icon: "$fa-magic",
                    size: "small",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.modifyAutoCompletion()), ["stop"])),
                    class: "ml-2",
                    color: _ctx.autoCompletion ? 'primary' : 'grey'
                  }, null, 8, ["color"]),
                  _createVNode(_component_v_btn_trash, {
                    onClick: _ctx.removeItem,
                    class: "mr-2",
                    size: "small"
                  }, null, 8, ["onClick"])
                ])
              ]),
              _createElementVNode("td", _hoisted_5, [
                _createVNode(_component_v_select, {
                  modelValue: _ctx.log,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.log) = $event)),
                  items: _ctx.logs,
                  "hide-details": "",
                  outlined: "",
                  tabindex: (_ctx.editionIndex + 1) * 100 + 1,
                  size: "small",
                  "item-title": (item) => item.text
                }, null, 8, ["modelValue", "items", "tabindex", "item-title"])
              ]),
              _createElementVNode("td", _hoisted_6, [
                _createVNode(_component_oss_date_picker, {
                  modelValue: _ctx.date,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.date) = $event)),
                  textFieldReadOnly: false,
                  filterWithoutClosedAccountingPeriods: true,
                  "hide-details": true,
                  tabindex: (_ctx.editionIndex + 1) * 100 + 2,
                  onTab: _ctx.onTabOnDate,
                  autofocus: ""
                }, null, 8, ["modelValue", "tabindex", "onTab"])
              ]),
              _createElementVNode("td", _hoisted_7, [
                (!_ctx.bankTransactionId)
                  ? (_openBlock(), _createBlock(_component_v_text_field, {
                      key: 0,
                      modelValue: _ctx.invoiceNumber,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.invoiceNumber) = $event)),
                      "hide-details": "",
                      "single-line": "",
                      readonly: _ctx.readonly,
                      tabindex: (_ctx.editionIndex + 1) * 100 + 3,
                      size: "small"
                    }, null, 8, ["modelValue", "readonly", "tabindex"]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("td", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("table", _hoisted_10, [
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingLines, (line, index) => {
                        return (_openBlock(), _createBlock(_component_AccountingItemLine, {
                          key: index,
                          modelValue: _ctx.accountingLines[index],
                          "onUpdate:modelValue": ($event: any) => ((_ctx.accountingLines[index]) = $event),
                          ref_for: true,
                          ref: 'line_' + index,
                          index: index,
                          company: _ctx.selectedCompany,
                          "enable-stock": _ctx.enableStock,
                          addQuantityColumn: _ctx.addQuantityColumn,
                          additionalQuantityColumns: _ctx.additionalQuantityColumns,
                          accountableAccounts: _ctx.accountableAccounts,
                          defaultWording: _ctx.generalWording,
                          companyTags: _ctx.companyTags,
                          showDueDateColumn: _ctx.showDueDateColumn,
                          autoCompletion: _ctx.autoCompletion,
                          focusedElement: _ctx.focusedElement,
                          editionIndex: _ctx.editionIndex,
                          onAccountingLinesPage: _ctx.onAccountingLinesPage,
                          onInsertLineAfter: ($event: any) => (_ctx.insertLineAfter(index)),
                          onAccountableAccountChanged: ($event: any) => (
                                                _ctx.onAccountableAccountChanged(index)
                                            ),
                          onItemCreditChanged: ($event: any) => (_ctx.onLineAmountSignedChanged(index)),
                          onItemDebitChanged: ($event: any) => (_ctx.onLineAmountSignedChanged(index)),
                          onItemWordingChanged: _ctx.getDisabledValidation,
                          onFocus: _ctx.onLineFocus,
                          onRemoveLine: _ctx.removeLine,
                          onPreviousLine: _ctx.onPreviousLine,
                          onNextLine: _ctx.onNextLine,
                          onOnFirstLineWordingChange: _ctx.updateWording,
                          onFocusOnDate: _ctx.focusOnDate,
                          onFocusOnWording: ($event: any) => (_ctx.focusOnWording(index)),
                          onTabOnCredit: ($event: any) => (_ctx.tabOnCredit(index))
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "index", "company", "enable-stock", "addQuantityColumn", "additionalQuantityColumns", "accountableAccounts", "defaultWording", "companyTags", "showDueDateColumn", "autoCompletion", "focusedElement", "editionIndex", "onAccountingLinesPage", "onInsertLineAfter", "onAccountableAccountChanged", "onItemCreditChanged", "onItemDebitChanged", "onItemWordingChanged", "onFocus", "onRemoveLine", "onPreviousLine", "onNextLine", "onOnFirstLineWordingChange", "onFocusOnDate", "onFocusOnWording", "onTabOnCredit"]))
                      }), 128))
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]),
        (!_ctx.isBalanced)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("table", _hoisted_12, [
                _createElementVNode("tbody", null, [
                  _createElementVNode("tr", null, [
                    _cache[10] || (_cache[10] = _createElementVNode("td", {
                      width: "25%",
                      align: "right",
                      class: "pr-2"
                    }, "Total", -1)),
                    _createElementVNode("td", _hoisted_13, [
                      _createVNode(_component_oss_text_field, {
                        "hide-details": true,
                        suffix: "€",
                        "single-line": "",
                        dense: "",
                        outlined: "",
                        readonly: "",
                        disabled: "",
                        "model-value": _ctx.totalDebit
                      }, null, 8, ["model-value"])
                    ]),
                    _createElementVNode("td", _hoisted_14, [
                      _createVNode(_component_oss_text_field, {
                        "hide-details": true,
                        suffix: "€",
                        "single-line": "",
                        dense: "",
                        outlined: "",
                        readonly: "",
                        disabled: "",
                        "model-value": _ctx.totalCredit
                      }, null, 8, ["model-value"])
                    ]),
                    _createElementVNode("td", _hoisted_15, [
                      _createVNode(_component_oss_text_field, {
                        "hide-details": true,
                        suffix: "€",
                        "single-line": "",
                        dense: "",
                        outlined: "",
                        readonly: "",
                        disabled: _ctx.totalDebit === _ctx.totalCredit,
                        error: _ctx.totalDebit !== _ctx.totalCredit,
                        "model-value": _ctx.totalDiff
                      }, null, 8, ["disabled", "error", "model-value"])
                    ]),
                    (_ctx.showDueDateColumn)
                      ? (_openBlock(), _createElementBlock("td", _hoisted_16))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        _cache[16] || (_cache[16] = _createElementVNode("br", null, null, -1)),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_btn_icon, {
              icon: "$fa-magic",
              size: "small",
              onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.modifyAutoCompletion()), ["stop"])),
              color: _ctx.autoCompletion ? 'primary' : 'grey'
            }, null, 8, ["color"]),
            _createVNode(_component_v_select_filled, {
              modelValue: _ctx.log,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.log) = $event)),
              items: _ctx.logs,
              "hide-details": "",
              outlined: "",
              class: "pl-2",
              tabindex: "1",
              density: "compact",
              "item-title": "text"
            }, null, 8, ["modelValue", "items"])
          ]),
          _createElementVNode("div", _hoisted_20, [
            _createVNode(_component_oss_date_picker_filled, {
              modelValue: _ctx.date,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.date) = $event)),
              textFieldReadOnly: false,
              filterWithoutClosedAccountingPeriods: true,
              "hide-details": true,
              label: "Date",
              tabindex: "1",
              autofocus: "",
              "data-cy": "Edition-journalDate"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_v_text_field_filled, {
              modelValue: _ctx.generalWording,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.generalWording) = $event)),
              outlined: "",
              "hide-details": "",
              tabindex: "1",
              density: "compact"
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_22, [
            (!_ctx.bankTransactionId)
              ? (_openBlock(), _createBlock(_component_v_text_field_filled, {
                  key: 0,
                  modelValue: _ctx.invoiceNumber,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.invoiceNumber) = $event)),
                  label: "N° de pièce",
                  regular: "",
                  "hide-details": "",
                  readonly: _ctx.readonly,
                  density: "compact"
                }, null, 8, ["modelValue", "readonly"]))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.documentId && !_ctx.bankTransactionId && !_ctx.zTillReceiptId && !_ctx.expenseReportId)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_FreeTag, {
                  inPrimaryLog: _ctx.type,
                  inLogTagId: _ctx.logTagId,
                  companyTags: _ctx.allCompanyTags,
                  company: _ctx.selectedCompany,
                  onOnTagsChanged: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onTagsChanged($event)))
                }, null, 8, ["inPrimaryLog", "inLogTagId", "companyTags", "company"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            (_ctx.enableDuplicate)
              ? _withDirectives((_openBlock(), _createBlock(_component_v_btn_icon, {
                  key: 0,
                  icon: "$oss-duplicate",
                  size: "small",
                  onClick: _withModifiers(_ctx.duplicate, ["stop"])
                }, null, 8, ["onClick"])), [
                  [_directive_tooltip, 'Dupliquer']
                ])
              : _createCommentVNode("", true),
            _withDirectives(_createVNode(_component_v_btn_icon, {
              icon: "$fa-arrow-right-left",
              onClick: _ctx.revert,
              size: "small"
            }, null, 8, ["onClick"]), [
              [_directive_tooltip, 'Inverser le sens de l\'écriture']
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("table", _hoisted_26, [
            _createElementVNode("thead", null, [
              _createElementVNode("tr", null, [
                _cache[11] || (_cache[11] = _createElementVNode("th", {
                  style: {"text-align":"center"},
                  width: "35%"
                }, "Compte", -1)),
                _cache[12] || (_cache[12] = _createElementVNode("th", {
                  style: {"text-align":"center"},
                  width: "30%"
                }, "Libellé", -1)),
                (_ctx.addQuantityColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_27, "Produit"))
                  : _createCommentVNode("", true),
                (_ctx.addQuantityColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_28, "Quantité"))
                  : _createCommentVNode("", true),
                (_ctx.additionalQuantityColumns)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_29, " Éléments "))
                  : _createCommentVNode("", true),
                _cache[13] || (_cache[13] = _createElementVNode("th", { width: "7%" }, "Débit", -1)),
                _cache[14] || (_cache[14] = _createElementVNode("th", { width: "7%" }, "Crédit", -1)),
                (_ctx.showDueDateColumn)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_30, "Echéance"))
                  : _createCommentVNode("", true),
                _cache[15] || (_cache[15] = _createElementVNode("th", { width: "7%" }, "Action", -1))
              ])
            ]),
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.accountingLines, (line, index) => {
                return (_openBlock(), _createBlock(_component_AccountingItemLine, {
                  key: index,
                  modelValue: _ctx.accountingLines[index],
                  "onUpdate:modelValue": ($event: any) => ((_ctx.accountingLines[index]) = $event),
                  disabledTrash: _ctx.accountingLines.length <= 2 || line.isBankTransaction,
                  ref_for: true,
                  ref: 'line_' + index,
                  index: index,
                  type: _ctx.type,
                  company: _ctx.selectedCompany,
                  "enable-stock": _ctx.enableStock,
                  addQuantityColumn: _ctx.addQuantityColumn,
                  additionalQuantityColumns: _ctx.additionalQuantityColumns,
                  accountableAccounts: _ctx.accountableAccounts,
                  defaultWording: _ctx.generalWording,
                  companyTags: _ctx.companyTags,
                  showDueDateColumn: _ctx.showDueDateColumn,
                  autoCompletion: _ctx.autoCompletion,
                  focusedElement: _ctx.focusedElement,
                  onInsertLineAfter: ($event: any) => (_ctx.insertLineAfter(index)),
                  onAccountableAccountChanged: ($event: any) => (_ctx.onAccountableAccountChanged(index)),
                  onItemCreditChanged: ($event: any) => (_ctx.onLineAmountSignedChanged(index)),
                  onItemDebitChanged: ($event: any) => (_ctx.onLineAmountSignedChanged(index)),
                  onItemWordingChanged: _ctx.getDisabledValidation,
                  onFocus: _ctx.onLineFocus,
                  onRemoveLine: _ctx.removeLine,
                  onPreviousLine: _ctx.onPreviousLine,
                  onNextLine: _ctx.onNextLine,
                  onFocusOnDate: _ctx.focusOnDate,
                  onFocusOnWording: ($event: any) => (_ctx.focusOnWording(index))
                }, null, 8, ["modelValue", "onUpdate:modelValue", "disabledTrash", "index", "type", "company", "enable-stock", "addQuantityColumn", "additionalQuantityColumns", "accountableAccounts", "defaultWording", "companyTags", "showDueDateColumn", "autoCompletion", "focusedElement", "onInsertLineAfter", "onAccountableAccountChanged", "onItemCreditChanged", "onItemDebitChanged", "onItemWordingChanged", "onFocus", "onRemoveLine", "onPreviousLine", "onNextLine", "onFocusOnDate", "onFocusOnWording"]))
              }), 128)),
              _createElementVNode("tr", null, [
                _createElementVNode("td", {
                  colspan: 2 + (_ctx.additionalQuantityColumns ? 3 : 0),
                  align: "right",
                  class: "pr-2"
                }, " Total ", 8, _hoisted_31),
                _createElementVNode("td", null, [
                  _createVNode(_component_oss_text_field, {
                    "hide-details": true,
                    suffix: "€",
                    "single-line": "",
                    dense: "",
                    outlined: "",
                    readonly: "",
                    disabled: "",
                    "model-value": _ctx.totalDebit
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_oss_text_field, {
                    "hide-details": true,
                    suffix: "€",
                    "single-line": "",
                    dense: "",
                    outlined: "",
                    readonly: "",
                    disabled: "",
                    "model-value": _ctx.totalCredit
                  }, null, 8, ["model-value"])
                ]),
                _createElementVNode("td", null, [
                  _createVNode(_component_oss_text_field, {
                    "hide-details": true,
                    suffix: "€",
                    "single-line": "",
                    dense: "",
                    outlined: "",
                    readonly: "",
                    disabled: _ctx.totalDebit === _ctx.totalCredit,
                    error: _ctx.totalDebit !== _ctx.totalCredit,
                    "model-value": _ctx.totalDiff
                  }, null, 8, ["disabled", "error", "model-value"])
                ]),
                (_ctx.showDueDateColumn)
                  ? (_openBlock(), _createElementBlock("td", _hoisted_32))
                  : _createCommentVNode("", true)
              ])
            ])
          ])
        ])
      ]))
}